import Debug from '@/components/debug';
import Link from 'next/link';
import {
  useHierarchicalMenu,
  UseHierarchicalMenuProps,
} from 'react-instantsearch';
import clsx from 'clsx';
import { getNameFromCategorySlug } from '@/lib/algolia/getNameFromCategorySlug';

type CategoryRefinementProps = UseHierarchicalMenuProps & {
  rootPath?: string;
  nameRootPath?: string;
  attributes: UseHierarchicalMenuProps['attributes'];
  nameAttributes?: UseHierarchicalMenuProps['attributes'];
  className?: string;
};

export function CategoryRefinement(props: CategoryRefinementProps) {
  const { attributes, className, rootPath } = props;

  const { items, createURL } = useHierarchicalMenu({
    attributes: attributes,
    rootPath: rootPath,
  });

  return (
    <nav
      className={clsx(
        'flex flex-wrap gap-2 items-center justify-center',
        className
      )}
    >
      {items.map((slug) => {
        // hack for removing trailing slash
        const url = createURL(slug.value);
        const title = getNameFromCategorySlug(slug.label) || slug.label;
        return (
          <Link
            key={slug.value}
            href={url}
            className="bg-neutral-30 rounded p-3 px-4 text-xs hover:bg-neutral-40 first-letter:capitalize"
          >
            {title}
          </Link>
        );
      })}
    </nav>
  );
}
